/** Espaço reservado para telas ainda não implementadas do roteiro (PLANO seção 10). */
export default function EmBreve({ titulo, descricao, secaoPlano }) {
  return (
    <div className="pagina">
      <header className="pagina-cabecalho">
        <h1>{titulo}</h1>
      </header>
      <div className="cartao em-breve">
        <p>{descricao}</p>
        {secaoPlano && (
          <p className="referencia">
            Especificação: <code>PLANO-SAAS-ATENDIMENTO-LEADS.md</code> — seção {secaoPlano}
          </p>
        )}
      </div>
    </div>
  );
}
